import { env, envBoolean } from './init';

/** Относительный адрес API (прод-сборка) превращается в абсолютный по домену, с которого открыт клиент. */
const absoluteUrl = (url: string): string => {
    const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
    return new URL(url, origin).href.replace(/\/$/, '');
};

const base_api_url = absoluteUrl(env(process.env.BASE_API_URL));
const api_url = absoluteUrl(env(process.env.API_URL));
const serviceId = env(process.env.SERVICE_ID);
const app = env(process.env.APP) as 'pusk' | 'atb';
let isDebugMessagesEnabled = ['development', 'staging'].includes(process.env.VARIANT || 'development');

const config = {
    app: app,
    base_api_url,
    api_url,
    currentSchema: env(process.env.CURRENT_SCHEMA),
    serviceId: env(process.env.SERVICE_ID),
    serviceName: env(process.env.SERVICE_NAME),
    serviceVal: env(process.env.SERVICE_VAL),
    //токен и лайфтайм сессии
    idToken: env(process.env.ID_TOKEN),
    lifetimeToken: env(process.env.LIFETIME_TOKEN),
    lifetimeValue: 12 * 60 * 60 * 1000, //12 часов, в милисекундах

    //параметры сессии
    currUserFIO: 'currUserFIO:' + serviceId,
    currUserRoles: 'currUserRoles:' + serviceId,
    currExtUserId: 'currExtUserId:' + serviceId,
    currUserId: 'currUserId:' + serviceId,
    currUserPersonId: 'currUserPersonId:' + serviceId,
    sysServiceOrg: 'sysServiceOrg:' + serviceId,

    //apiKey для доступа к FileStore сервису (в БД file_store.file_store_config)
    apiKeyFileStore: env(process.env.API_KEY_FILESTORE),
    apiURLFileStore: absoluteUrl(env(process.env.API_URL_FILESTORE)),
    apiURLFileStoreV2: absoluteUrl(env(process.env.API_URL_FILESTORE_V2)),
    apiUrlPlatform: absoluteUrl(env(process.env.API_URL_PLATFORM)),

    // apiUrlFastify: 'http://localhost:3030', // env(process.env.API_URL_FASTIFY),
    apiUrlFastify: absoluteUrl(env(process.env.API_URL_FASTIFY)),
    apiUrlFilestoreV2Previews: absoluteUrl(env(process.env.API_URL_FILESTORE_V2_PREVIEWS)),
    /** Печатные формы старого Java-бэкенда ЁЖИК (КП, сметы). */
    legacyReportUrl: env(process.env.LEGACY_REPORT_URL, ''),
    daDataToken: env(process.env.DADATA_TOKEN),
    //системные параметры
    systemPreference: `systemPreference-${app}:`,

    // инфолог - "Больше не показывать"
    systemDialogOpenAuto: 'systemDialogOpenAuto:' + serviceId,

    metrikaId: ((mId): null | number => {
        if (!mId || isNaN(+mId)) return null;
        return +mId;
    })(env(process.env.METRIKA_ID)),

    sentry: {
        dsn: env(process.env.SENTRY_DSN),
    },
    roles: {
        superadminCanDoAnything: envBoolean(process.env.ROLES_SUPERADMIN_CAN_DO_ANYTHING),
    },
    devContext: envBoolean(process.env.DEV_CONTEXT),
    debugMessages: {
        isEnabled: () => isDebugMessagesEnabled,
        setEnabled: (enabled = true) => (isDebugMessagesEnabled = enabled),
    },
    //параметры ГРИДа
    gridPreference: 'gridPreference:' + serviceId,

    login: 'login:' + serviceId,

    //НАСТРОЙКА ПАРАМЕТРОВ УЧЕТА - todo Надо вынести ее в настройку с привязкой к sys_service_org_link, чтобы по каждой организации были свои настройки
    accountingPolicy: {
        byOperationCategory: envBoolean(process.env.AP_BY_OPERATION_CATEGORY), //учет в разрезе Статей расходов/доходов (категорий)
        byProject: envBoolean(process.env.AP_BY_PROJECT), //учет в разрезе Статей расходов/доходов (категорий)
        byContract: envBoolean(process.env.AP_BY_CONTRACT), //учет в разрезе Договоров
        usePaymentRegister: envBoolean(process.env.AP_USE_PAYMENT_REGISTER), //true - учитывать суммы "К оплате" из "Реестра на оплату", иначе "К оплате" = "Сумма по счету"
        useContractService: envBoolean(process.env.AP_USE_CONTRACT_SERVICE), //true - вести Договоры в разрезе Сервисных периодов, иначе без Сервисных периодов
        operation: {
            //настройка для раздела Банковские операции
            operationCanBeSplit: envBoolean(process.env.AP_OPERATION_OPERATION_CAN_BE_SPLIT), //вкл/выкл функции разделения операции по Статьям, Контрагентам, Проектам (для master detail)
            createContractFromOperation: envBoolean(process.env.AP_OPERATION_CREATE_CONTRACT_FROM_OPERATION), //вкл/выкл функции создания договора из операции
            operationOld: envBoolean(process.env.AP_OPERATION_OLD), //вкл/выкл Переключатель на старый грид
        },
        contract: {
            //настройка для раздела Договора
            hideColumns: envBoolean(process.env.AP_CONTRACT_HIDE_COLUMNS), //для скрытия столбцов: Сумма аванса по Договору, Контакты и Код контракта
            showResponsibleUserColumn: envBoolean(process.env.AP_CONTRACT_SHOW_RESPONSIBLE_USER_COLUMN), //для скрытия/показа столбца "Ответственный"
            apContractShowServicePeriod: envBoolean(process.env.AP_CONTRACT_SHOW_SERVICE_PERIOD), // Отображать ли грид contract_service
            apContractShowDocumentOriginal: envBoolean(process.env.AP_CONTRACT_SHOW_DOCUMENT_ORIGINAL), // Отображать ли input на форме document_original,
            isComment: envBoolean(process.env.AP_CONTRACT_COMMENT),
        },
        invoice: {
            hidePaymentScheduleButton: envBoolean(process.env.AP_INVOICE_FORM_PAYMENT_SCHEDULE_BUTTON), // для скрытия/показа кнопки 'Создать периодический платеж'
            isComment: envBoolean(process.env.AP_INVOICE_COMMENT),
            isBtnDelivery: envBoolean(process.env.AP_INVOICE_BTN_DELIVERY),
            isCreateInvoiceCopy: envBoolean(process.env.AP_INVOICE_CREATE_INVOICE_COPY),
        },
        act: {
            isComment: envBoolean(process.env.AP_ACT_COMMENT),
        },
        gis: {
            isGis: envBoolean(process.env.AP_GIS),
        },
        isContractFieldRequired: envBoolean(process.env.AP_CONTRACT_FIELD_REQUIRED), // обязательное поле Договор
    },

    currentPath: 'currentPath:' + serviceId,

    ourContragent: 'ourContragent:' + serviceId,

    //функции по работе с localStorage
    getItemStorage: funcGetItemFromLocalStorage,
    setItemStorage: funcSetItemToLocalStorage,
    getGridParams: funcGetGridParamsFromLocalStorage,
    setGridViewPrefOverlay: funcSetGridViewPrefOverlay,
    currentVersion: env(process.env.CURRENT_VERSION),
    gitLatestCommitSha: env(process.env.GIT_LATEST_COMMIT_SHA),
    gitBranch: env(process.env.GIT_BRANCH),
    gitBuildNumber: env(process.env.GIT_PIPELINE),
    NODE_ENV: env(process.env.NODE_ENV) as 'development' | 'staging' | 'production',
    updateNotice: {
        shouldShow: () => localStorage.getItem('UPDATE_NOTICE') !== env(process.env.CURRENT_VERSION),
        setAlreadySeen: () => localStorage.setItem('UPDATE_NOTICE', env(process.env.CURRENT_VERSION)),
    },
};

(window as any)._DEBUG_ = () => config.debugMessages.setEnabled();

export default config;

function funcGetItemFromLocalStorage(itemKey: string) {
    const item = localStorage.getItem(itemKey);
    if (item != null && IsJsonString(item)) {
        return JSON.parse(item);
    } else {
        return item;
    }
}

const defaultGeneralGridPref = {
    flex: true,
    wrapText: false,
    align: {
        numeric: 'right',
    },
    singleClickEdit: false,
};

const gridViewPrefOverlay = new Map<string, any>();

function funcSetGridViewPrefOverlay(componentName: string, pref: any | null) {
    if (!componentName) return;
    if (pref) gridViewPrefOverlay.set(componentName, pref);
    else gridViewPrefOverlay.delete(componentName);
}

function funcGetGridParamsFromLocalStorage(component?: string | null) {
    // @ts-ignore
    // Имя компонента если есть для получения настроек конфига
    const componentName = this?.$?.type?.name ?? component;

    if (componentName && gridViewPrefOverlay.has(componentName)) {
        return gridViewPrefOverlay.get(componentName);
    }

    const systemItemKey = componentName ? `${config.systemPreference}${componentName}` : null;

    if (!systemItemKey) return defaultGeneralGridPref;

    const systemPreference = funcGetItemFromLocalStorage(systemItemKey);

    if (systemPreference) return systemPreference;
    else return defaultGeneralGridPref;
}

function funcSetItemToLocalStorage(itemKey: string, value: any) {
    localStorage.setItem(itemKey, JSON.stringify(value));
}

function IsJsonString(str: string) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
